import { useCart } from "./StoreLayout";
import { formatIDR } from "@/lib/format";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { toast } from "sonner";

export default function StoreWishlist() {
  const { wishlist, toggleWish, addToCart } = useCart();
  if (wishlist.length === 0) {
    return (
      <div className="text-center py-20">
        <Heart className="w-14 h-14 text-kiyana-muted mx-auto mb-3" />
        <div className="font-serif-fashion text-2xl mb-2">Wishlist Kosong</div>
        <div className="text-sm text-kiyana-muted">Simpan koleksi favoritmu dan kembali lagi kapan saja.</div>
      </div>
    );
  }
  return (
    <div className="space-y-4 animate-fade-up">
      <h1 className="font-serif-fashion text-3xl">Wishlist</h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {wishlist.map((p) => (
          <div key={p.id} className="bg-white rounded-xl overflow-hidden border border-kiyana-soft">
            <Link to={`/store/product/${p.id}`} className="block aspect-square overflow-hidden">
              <img src={p.image} alt={p.name} className="w-full h-full object-cover" />
            </Link>
            <div className="p-3">
              <div className="text-sm font-medium line-clamp-2 min-h-10">{p.name}</div>
              <div className="text-kiyana-maroon font-bold text-sm mt-1">{formatIDR(p.price)}</div>
              <div className="flex gap-1.5 mt-2">
                <button onClick={() => { addToCart(p); toast.success("Ditambahkan"); }} className="flex-1 h-8 rounded-full bg-kiyana-maroon text-white text-xs font-semibold">+ Keranjang</button>
                <button onClick={() => toggleWish(p)} className="w-8 h-8 rounded-full border border-kiyana-soft text-kiyana-maroon">×</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
